export const ROUTES = {
  RESOURCES: "/resources",
  QUICK_START: "/resources/quick-start",
};

export const getResourcePath = (slug) => `${ROUTES.RESOURCES}/${slug}`;
